import type { HTMLAttributes } from 'react';
import { cx } from '../../utils/cx.js';
import styles from './DataTable.module.css';

export type DataTableCellPart = 'header' | 'body' | 'actions';
export type DataTableCellPin = 'none' | 'start' | 'end';
export type DataTableDensity = 'default' | 'compact' | 'comfortable';

export type DataTableCellAttrs = HTMLAttributes<HTMLTableCellElement> & {
  'data-wp-datatable-part': DataTableCellPart | 'actions' | 'header';
  'data-wp-datatable-pin': DataTableCellPin;
};

export function wpPinToCellPin(side: 'start' | 'end' | undefined): DataTableCellPin {
  if (side === 'start') return 'start';
  if (side === 'end') return 'end';
  return 'none';
}

export function getDataTableCellProps(options: {
  element: 'th' | 'td';
  part: DataTableCellPart;
  pin?: DataTableCellPin;
  density?: DataTableDensity;
  extraClassName?: string;
}): DataTableCellAttrs {
  const pin = options.pin ?? 'none';
  const compact = (options.density ?? 'default') === 'compact';

  if (options.element === 'th') {
    const isActions = options.part === 'actions';
    return {
      className: cx(
        styles.th,
        isActions && styles.thAction,
        isActions && compact && styles.thActionCompact,
        pin === 'start' && styles.thStickyStart,
        pin === 'end' && styles.thStickyEnd,
        options.extraClassName,
      ),
      'data-wp-datatable-part': isActions ? 'actions' : 'header',
      'data-wp-datatable-pin': pin,
    } as DataTableCellAttrs;
  }

  const isActions = options.part === 'actions';
  return {
    className: cx(
      styles.td,
      isActions && styles.tdActions,
      isActions && compact && styles.tdActionsCompact,
      pin === 'start' && styles.tdStickyStart,
      pin === 'end' && styles.tdStickyEnd,
      options.extraClassName,
    ),
    'data-wp-datatable-part': isActions ? 'actions' : 'body',
    'data-wp-datatable-pin': pin,
  } as DataTableCellAttrs;
}
